import { FC } from "react";
import { CompetitionContainer } from "./styled";
import { CompetitionCard } from "./CompetitionCard";
import { Competition } from "@brg/api";

const CompetitionGrid: FC<{ competitions: Competition[], isProfile?: boolean, isMainPage?: boolean }> = ({ competitions, isProfile, isMainPage }) => {

  return (
    <CompetitionContainer isProfile={isProfile}>
      {competitions
        .map((competitionProps) => {
            return (
              <CompetitionCard
                key={competitionProps?.competitionId}
                isNewType
                isProfile={isProfile}
                competitionProps={competitionProps}
                isMainPage={isMainPage}
              />
            )
          }
        )}
    </CompetitionContainer>
  )
}

export default CompetitionGrid;import { FC } from "react";
import { CompetitionContainer } from "./styled";
import { CompetitionCard } from "./CompetitionCard";
import { Competition } from "@brg/api";

const CompetitionGrid: FC<{ competitions: Competition[], isProfile?: boolean, isMainPage?: boolean }> = ({ competitions, isProfile, isMainPage }) => {

  return (
    <CompetitionContainer isProfile={isProfile}>
      {competitions
        .map((competitionProps) => {
            return (
              <CompetitionCard
                key={competitionProps?.competitionId}
                isNewType
                isProfile={isProfile}
                competitionProps={competitionProps}
                isMainPage={isMainPage}
              />
            )
          }
        )}
    </CompetitionContainer>
  )
}

export default CompetitionGrid;